export type GlobalPresenceStatus = 'online' | 'offline' | 'mixed';

export const getGlobalPresenceStatus = (
	availableSpacesCount: number,
	totalSpaces: number,
): GlobalPresenceStatus => {
	if (availableSpacesCount === 0) return 'offline';
	if (availableSpacesCount < totalSpaces) return 'mixed';
	return 'online';
};
